
import { Mail, Users, Target, Send, Sparkles } from "lucide-react";

export const BenefitsSection = () => {
  return (
    <div className="space-y-8 mt-12">
      <h2 className="text-2xl font-bold text-teal-700">Key Benefits</h2>
      
      <div className="grid gap-6 sm:grid-cols-2">
        <div className="p-4 rounded-lg border bg-gradient-to-br from-white to-cyan-50/50 backdrop-blur-sm space-y-3 hover:shadow-lg transition-all">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-cyan-100 flex items-center justify-center flex-shrink-0">
              <Mail className="h-5 w-5 text-cyan-600" />
            </div>
            <h3 className="font-semibold text-lg text-cyan-700">100% Personalized Emails</h3>
          </div>
          <p className="text-gray-600 text-sm">Each email is tailored to your client's personality, likes, and milestones—so they'll feel the love.</p>
        </div>

        <div className="p-4 rounded-lg border bg-gradient-to-br from-white to-teal-50/50 backdrop-blur-sm space-y-3 hover:shadow-lg transition-all">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0">
              <Users className="h-5 w-5 text-teal-600" />
            </div>
            <h3 className="font-semibold text-lg text-teal-700">Rebuild Connections & Win Referrals</h3>
          </div>
          <p className="text-gray-600 text-sm">Stay top-of-mind with your favorite clients and make it easier than ever to get referrals.</p>
        </div>

        <div className="p-4 rounded-lg border bg-gradient-to-br from-white to-blue-50/50 backdrop-blur-sm space-y-3 hover:shadow-lg transition-all">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <Target className="h-5 w-5 text-blue-600" />
            </div>
            <h3 className="font-semibold text-lg text-blue-700">Client Personas Done for You</h3>
          </div>
          <p className="text-gray-600 text-sm">For five or more clients, we'll create detailed client profiles to help you target the right audience at the right time with the perfect message.</p>
        </div>

        <div className="p-4 rounded-lg border bg-gradient-to-br from-white to-purple-50/50 backdrop-blur-sm space-y-3 hover:shadow-lg transition-all">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center flex-shrink-0">
              <Send className="h-5 w-5 text-purple-600" />
            </div>
            <h3 className="font-semibold text-lg text-purple-700">Instant Communication, Zero Guesswork</h3>
          </div>
          <p className="text-gray-600 text-sm">With just one click, you'll have professional, polished emails ready to send.</p>
        </div>
      </div>

      <p className="text-gray-600 font-semibold flex items-center justify-center gap-2">
        <Sparkles className="h-4 w-4 text-teal-500" />
        Join the professionals who trust us with communications to their best clients
      </p>
    </div>
  );
};
